// eslint-disable-next-line no-unused-vars
import * as Updates from 'expo-updates';

import {Platform, View} from 'react-native';

import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getDatabase} from 'src/Utils/db';
import {setVersionInfo} from './Redux/reducers/app_info.reducer';

import {SafeAreaProvider} from 'react-native-safe-area-context';

// main navigation stack
import RootNavigationStack from 'src/Nav/RootNavigationStack';
// redux

import VersionNumber from 'react-native-version-number';

import LoadingIndicator from './Modules/CommonView/LoadingIndicator';
import GuardianWrapper from './Modules/GuardianAngel/GuardianWrapper';

//////// navigation && notifications handler component
import {dispatchAction} from 'src/Utils/helpers';
import {mmkvStorage} from 'src/Utils/mmkvStorage';
import {
  deleteFirebaseListener,
  saveFirebaseListener,
} from './Redux/reducers/current_screen.reducer';

// import {DevSettings} from 'react-native';

import * as Sentry from 'sentry-expo';

import * as Device from 'expo-device';
import ControllersWrapper from './Controllers/ContollersWrapper';
import UpgradeView from './UpgradeView';
import {checkIfLocalServerAvailable} from './Utils/helpers';

import Constants from 'expo-constants';

if (Platform.OS !== 'web') {
  Sentry.init({
    dsn: 'https://b859f3d1065741039551be7a6b7d2aee@o1124145.ingest.sentry.io/6639485',
    enableInExpoDevelopment: true,
    tracesSampleRate: 1.0,
    release: Constants.manifest?.revisionId,
    // integrations: [
    //   new RewriteFrams({
    //     iteratee: (frame) => {
    //       if (frame.filename) {
    //         // the values depend on what names you give the bundle files you are uploading to Sentry
    //         frame.filename =
    //           Platform.OS === 'android'
    //             ? 'app:///index.android.bundle'
    //             : 'app:///main.jsbundle';
    //       }
    //       return frame;
    //     },
    //   }),
    // ],
    debug: __DEV__, // If `true`, Sentry will try to print out useful debugging information if something goes wrong with sending the event. Set it to `false` in production
  });
}

if (__DEV__ || !Device.isDevice) {
  Sentry.Browser.setTag('environment', 'Development');
} else {
  Sentry.Browser.setTag('environment', 'Production');
}

// Props passed in from use copilot
const App = () => {
  console.log('App.js is rendering');
  const dispatch = useDispatch();

  const status = useSelector((state) => state.app_info?.status);
  const expoUpdateAvailable = useSelector((state) => {
    if (window) {
      window.state = state;
    }
    return state.app_info?.expoUpdateAvailable;
  });

  useEffect(() => {
    // componentDidMount
    if (!__DEV__) {
      return console.log('not dev');
    }
    checkIfLocalServerAvailable();

    // Add our toggle command to the menu
    // console.log({DevSettings});
    // if (__DEV__) {
    //   DevSettings?.addMenuItem?.('Hard Refresh App', () => {
    //     // Perform your logic here
    //     mmkvStorage.clearAll();
    //     dispatchAction({type: 'HARD_RESET'});
    //     navigationRef.goBack('App.js');
    //     navigationRef.goBack('App.js');
    //     navigationRef.goBack('App.js');
    //     navigationRef.goBack('App.js');
    //     navigationRef.goBack('App.js');
    //     navigationRef.navigate('AppIntroSwiper');
    //     Updates.reloadAsync();
    //   });
    // }
  }, []);

  // have to use old method
  // dont use other
  useEffect(() => {
    let versionNumber = VersionNumber.appVersion || VersionNumber.versionCode;

    versionNumber = versionNumber?.replace(/\./gi, '_');
    const featurePath = `versionInfo/${Platform.OS}/${versionNumber}`;
    var dataRef;

    const listenerId = Math.round(Math.random() * 1000000000);

    dataRef = getDatabase().ref(featurePath);
    var onChange = dataRef.on('value', async (snapshot) => {
      const versionInfo = await snapshot.val();
      console.log('useFirebaseData newData', {versionInfo, featurePath});
      const parsedVersionInfo = {
        passportPrice: versionInfo?.passportPrice || 39.99,
        passportRechargePrice: versionInfo?.passportRechargePrice || 29.99,
        playTestState:
          (!!versionInfo?.playTest || !versionInfo) && Platform.OS == 'ios',
        versionNumber,
        showOnlyExplorerPass: versionInfo?.showOnlyExplorerPass || false,
        status: versionInfo?.status || false,
      };
      // Alert.alert('version info', JSON.stringify(parsedVersionInfo));
      console.log('the new received version info is ', {parsedVersionInfo});
      dispatch(setVersionInfo(parsedVersionInfo));
      mmkvStorage.set('versionInfo', JSON.stringify(parsedVersionInfo));
    });
    dispatchAction(saveFirebaseListener({[listenerId]: featurePath}));
    return () => {
      dataRef?.off?.('value', onChange);
      dispatchAction(deleteFirebaseListener(listenerId));
    };
  });

  // return <View />;
  if (status == 'upgrade' || expoUpdateAvailable) {
    return <UpgradeView />;
  } else {
    console.log('not in playtest');
    return (
      <SafeAreaProvider>
        <View
          style={{
            flex: 1,
            position: 'relative',
            backgroundColor: global.color.orange,
          }}>
          <RootNavigationStack />
          <LoadingIndicator />
          <ControllersWrapper />
          <GuardianWrapper />
          <LoadingIndicator />
        </View>
      </SafeAreaProvider>
    );
  }
};

export default App;
